export default "__VITE_ASSET__BEoxA6p$__"